const emergencyBt = {
	buttons: {
		gas: 'གྱསི་སི་ལིན་ཌར་',
		medicine: 'འཕྲལ་གྱི་སྨན་'
	},
	common: {
		nameLabel: 'ཁྱེད་ཀྱི་མིང་',
		phoneLabel: 'ཁ་པར་ཨང་',
		villageLabel: 'གྲོང་གསེབ/ཁུལ་',
		houseNumberLabel: 'ཁྱིམ་ཨང་',
		detailsLabel: 'ཁ་གསལ་',
		detailsPlaceholder: 'དགོས་མཁོའི་ཁ་གསལ་ཡོད་ཚད་བྱིན།',
		districtLabel: 'ལྷོད་ཁུལ་',
		upazillaLabel: 'ཡུལ་ཚོམ་',
		cancel: 'ཆ་མེད་'
	},
	gas: {
		title: 'གྱསི་སི་ལིན་ཌར་བསྐྱར་བགྲང་',
		companyLabel: 'གྱསི་ཚོང་ལས་',
		cylinderSizeLabel: 'སི་ལིན་ཌར་ཚད་',
		cylinderSizePlaceholder: 'སི་ལིན་ཌར་ཚད་གདམ།',
		quantityLabel: 'གྱངས་ཁ་',
		companies: {
			bashundhara: 'Bashundhara Gas',
			jamuna: 'Jamuna Gas',
			omera: 'Omera Gas',
			beximco: 'Beximco Gas',
			fresh: 'Fresh Gas',
			totalgaz: 'Totalgaz',
			others: 'གཞན་'
		},
		cylinderSizeOptions: {
			"12kg": '12 ཀི་ལོ་',
			"33kg": '33 ཀི་ལོ་',
			"45kg": '45 ཀི་ལོ་'
		},
		price: {
			header: 'གློག་འཕྲིན་གནས་ཚུལ་',
			unitPrice: 'གཅིག་གི་གློག་འཕྲིན་',
			subtotal: 'བསྡུས་རྩིས་',
			delivery: 'གཏོང་ལེན་གློག་འཕྲིན་',
			total: 'བསྡུས་བཅད་',
			note: '* འབྲིང་ལས་དངུལ་ཐོབ་ཚུགས།',
			unitSuffix: 'ཆུ་ཚོད་'
		},
		orderNow: 'ད་ལྟ་གནང་།'
	},
	medicine: {
		title: 'འཕྲལ་གྱི་སྨན་ཞབས་ཞུ་',
		medicineNameLabel: 'སྨན་མིང་',
		medicineNamePlaceholder: 'ག་དེམ་ཅིག་དགོས།',
		urgencyLabel: 'མགྱོགས་ཚད་',
		urgencyOptions: {
			normal: 'སྤྱིར་བཏང་',
			urgent: 'མྱུར་དུ་',
			emergency: 'མགྱོགས་མེད་'
		},
		prescriptionLabel: 'འཆང་འབྲི (ཡོད་ཚད་)',
		prescriptionPlaceholder: 'འཆང་འབྲི་ཡང་ན་སྨན་གྱི་ཁ་གསལ་',
		uploadNote: 'འཆང་འབྲི་སྨེལ་སྒྲིག་གདམ་ཁ་ཡོད། གཟུགས་པར་ཡང་ན་ PDF སྣོན་ཆོག',
		uploadButton: 'འཆང་འབྲི་སྣོན། (གདམ་ཁ)',
		selectedFilePrefix: 'སེལ་འཐུ་འབད་པའི་ཡིག་ཆ་:',
		submit: 'འཕྲལ་གྱི་གནང་བ་སྤྲོད།'
	}
};

export default emergencyBt;


